module.exports = __webpack_public_path__ + "img/scabbers_running_away.5a95df71.jpg";